import { UniversalFilterConfig } from "../../components/Filters/ReportFilter";

/**
 * 📄 Ventas por Formas de Pago
 *
 * Reporte:
 * Ventas
 *
 * Filtros requeridos:
 * - Fecha Desde
 * - Fecha Hasta
 *
 * Backend esperado:
 *
 * dateFrom
 * dateTo
 */
export const salesByPaymentMethodReportFilters: UniversalFilterConfig[] = [
    {
        name: "dateFrom",
        label: "Fecha Desde",
        type: "date",
        iconKey: "calendar",
    },
    {
        name: "dateTo",
        label: "Fecha Hasta",
        type: "date",
        iconKey: "calendar",
    },
];